export default "__VITE_ASSET__DmcFRCrZ__"